import React from "react";
import MuiTextField from "@mui/material/TextField";
import { styled } from "@mui/system";

const StyledTextField = styled(MuiTextField)(() => ({
  "&": {
    margin: "8px 0px",
  },
  "& label.Mui-focused": {
    color: "black",
  },

  "& input": {
    color: "black",
    width: "100%",
  },

  "& .MuiOutlinedInput-root": {
    background: "#ffffff",
    color: "black",
    borderRadius: "5px",

    "& label.Mui-focused": {
      color: "black",
    },

    "&.Mui-focused": {
      borderColor: "white",
    },

    "&.Mui-disabled": {
      backgroundColor: "#eee",
      color: "#757575",
    },
  },
}));

const TextField = (props) => {
  const {
    id,
    label,
    placeholder,
    type,
    variant,
    value,
    onChange,
    onBlur,
    error,
    helperText,
    disabled,
  } = props;

  const fieldProps = {
    id,
    placeholder,
    label,
    type,
    variant,
    value,
    onChange,
    onBlur,
    error,
    helperText,
    disabled,
  };

  return <StyledTextField {...fieldProps} />;
};

export default TextField;
